import { Ccp } from '@or-sdk/ccp';

import { useAuth } from '@/stores';

import config from '../config';

const instance = new Ccp({
  ccpApiUrl: config.CUSTOMER_PORTAL_API_URL,
  token: () => `USER ${useAuth().reactiveToken}`,
});

export default instance;
